"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.objectify = void 0;
var ramda_1 = require("ramda");
exports.objectify = ramda_1.curry(function (attribute, array) {
    return Object.assign.apply(Object, __spreadArray([{}], array.map(function (a) {
        var _a;
        return (_a = {}, _a[a[attribute]] = a, _a);
    })));
});
//# sourceMappingURL=objectify.js.map